export const LightImages = {
  stripe_logo: require('./IntegrationLogos/stripe-logo.svg').default,
  figma_logo: require('./IntegrationLogos/figma-logo.svg').default,
  github_logo: require('./IntegrationLogos/github-logo.svg').default,
  sentry_logo: require('./IntegrationLogos/sentry-logo.svg').default,
  zapier_logo: require('./IntegrationLogos/zapier-logo.svg').default,
  api_logo: require('./IntegrationLogos/api-logo.svg').default,
  vercel_logo: require('./IntegrationLogos/vercel-logo.svg').default,
  google_logo: require('./Google logo.svg').default,
  teamcamp_logo: require('./Teamcamp logo.svg').default,
  empty_profile: require('./emptystates/empty-profile.svg').default,
  customer_profile_empty: require('./customeprofilelight.svg').default,
  image_empty: require('./IcondefaultImage.svg').default,
  loading_state: require('./loadingstate.gif'),
  onBoarding_step1_profile: require('./profile.svg').default,
  mobile_onboarding: require('./taskmobile.png'),
  // empty state
  empty_favicon: require('./emptystates/emptyFaviconLight.svg').default,
  empty_brand_logo: require('./emptystates/emptyBrandLogoLight.svg').default,
  inbox_empty: require('./emptystates/inboxemptystate.svg').default,
  gif_empty: require('./emptystates/empty-gif.svg').default,
  customer_empty: require('./emptystates/customer-empty.svg').default,
  project_empty: require('./emptystates/projectLightEmpty.svg').default,
  no_project_found: require('./emptystates/noprojectfound.svg').default,
  invoice_empty: require('./emptystates/invoice-empty.svg').default,
  milestone_empty: require('./emptystates/milestonelightempty.svg').default,
  mytask_empty: require('./emptystates/lightMyTaskEmpty.svg').default,
  views_empty: require('./emptystates/viewempty.svg').default,
  time_tracking_empty: require('./emptystates/tracking-empty.svg').default,
  reports_empty: require('./emptystates/report-empty.svg').default,
  snap_record_empty: require('./emptystates/snaprecordempty.svg').default,
  api_empty: require('./emptystates/emptyApiKey.svg').default,
  ai_log_empty: require('./emptystates/aiLogEmpty.svg').default,
  files_list_empty: require('./emptystates/filesListLightEmpty.svg').default,
  version_history_empty: require('./emptystates/emptyversionhistory.svg').default,
  empty_repo: require('./emptystates/emptyrepolight.svg').default,
  no_repo_found: require('./emptystates/notfoundrepolight.svg').default,
  invoicing_empty_profile: require('./emptystates/emptyLogo.svg').default,
  // messages empty state
  chat_empty: require('./emptystates/emptymessagelight.svg').default,
  message_empty: require('./emptystates/lightmessageempty.svg').default,
  // notification background image
  desktop_background: require('./desktop-background-light.png'),
  notification_background: require('./notification-background-light.png'),
  overdue_background: require('./overdue-background-light.png'),
  desktop_app_mac: require('./desktopapp-mac.png'),
  message_unread: require('./message-unread-card-light-background.png'),
  // firebase stored images
  figma_icon:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FIcons%3DFill%2C%20Type%3DFile%2C%20Icon%20Name%3DFigma.png?alt=media&token=182ec435-8705-4131-9e42-f76e01d8cfea',
  cleanshot_icon:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fcleanshot_logo_2x.png?alt=media&token=6bf18f68-de54-4687-a010-e8f1c058cab5',
  prntscrn_icon:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FLightShot.png?alt=media&token=05979875-3f7c-4836-8242-7b10a8a12cf1',
  youtube_icon:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FYouTube_icon.png?alt=media&token=ef342c7b-16fc-4a2c-b245-8e9eb87ff785',
  video_play:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fvideoplay.png?alt=media&token=ef342c7b-16fc-4a2c-b245-8e9eb87ff785',
  app_logo:
    'https://images.ctfassets.net/6v3c95narsix/46TdQdAUAQMY1THcYm7kHL/9c7fdb28efe046377618b39e1a0ffde3/Teamcamp_default.svg'
};

export const DarkImages = {
  stripe_logo: require('./IntegrationLogos/stripe-logo.svg').default,
  figma_logo: require('./IntegrationLogos/figma-logo.svg').default,
  github_logo: require('./IntegrationLogos/github-dark-logo.svg').default,
  sentry_logo: require('./IntegrationLogos/sentry-dark-logo.svg').default,
  zapier_logo: require('./IntegrationLogos/zapier-logo.svg').default,
  api_logo: require('./IntegrationLogos/api-dark-logo.svg').default,
  vercel_logo: require('./IntegrationLogos/vercel-dark-logo.svg').default,
  google_logo: require('./Google logo.svg').default,
  teamcamp_logo: require('./Teamcamp logo.svg').default,
  empty_profile: require('./emptystates/darkEmptyProfile.svg').default,
  customer_profile_empty: require('./customerprofiledark.svg').default,
  image_empty: require('./IcondefaultImageDark.svg').default,
  loading_state: require('./loadingstate.gif'),
  onBoarding_step1_profile: require('./profile.svg').default,
  mobile_onboarding: require('./darktaskmobile.png'),
  // empty state
  empty_favicon: require('./emptystates/emptyFaviconDark.svg').default,
  empty_brand_logo: require('./emptystates/emptyBrandLogoDark.svg').default,
  inbox_empty: require('./emptystates/darkinboxempty.svg').default,
  gif_empty: require('./emptystates/empty-gifdark.svg').default,
  customer_empty: require('./emptystates/customerDarkEmpty.svg').default,
  project_empty: require('./emptystates/projectDarkEmpty.svg').default,
  no_project_found: require('./emptystates/noprojectfounddark.svg').default,
  invoice_empty: require('./emptystates/invoiceDarkEmptyLogo.svg').default,
  milestone_empty: require('./emptystates/milestonedarkempty.svg').default,
  mytask_empty: require('./emptystates/darkMyTaskEmpty.svg').default,
  views_empty: require('./emptystates/viewemptydark.svg').default,
  time_tracking_empty: require('./emptystates/darktimetrackingempty.svg').default,
  reports_empty: require('./emptystates/reportdarkempty.svg').default,
  snap_record_empty: require('./emptystates/darksnaprecordempty.svg').default,
  api_empty: require('./emptystates/emptyApiKeyDark.svg').default,
  ai_log_empty: require('./emptystates/aiLogEmptyDark.svg').default,
  files_list_empty: require('./emptystates/filesListDarkEmpty.svg').default,
  version_history_empty: require('./emptystates/darkemptyversionhistory.svg').default,
  empty_repo: require('./emptystates/emptyrepodark.svg').default,
  no_repo_found: require('./emptystates/notfoundrepodark.svg').default,
  invoicing_empty_profile: require('./emptystates/darkEmptyLogo.svg').default,
  // messages empty state
  chat_empty: require('./emptystates/darkmessageempty.svg').default,
  message_empty: require('./emptystates/darkemptymessage.svg').default,
  // notification background image
  desktop_background: require('./desktop-background-dark.png'),
  notification_background: require('./notification-background-dark.png'),
  overdue_background: require('./overdue-background-dark.png'),
  desktop_app_mac: require('./desktopapp-mac.png'),
  message_unread: require('./message-unread-card-dark-background.png'),
  // firebase stored images
  figma_icon:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FIcons%3DFill%2C%20Type%3DFile%2C%20Icon%20Name%3DFigma.png?alt=media&token=182ec435-8705-4131-9e42-f76e01d8cfea',
  cleanshot_icon:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fcleanshot_logo_2x.png?alt=media&token=6bf18f68-de54-4687-a010-e8f1c058cab5',
  prntscrn_icon:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FLightShot.png?alt=media&token=05979875-3f7c-4836-8242-7b10a8a12cf1',
  youtube_icon:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FYouTube_icon.png?alt=media&token=ef342c7b-16fc-4a2c-b245-8e9eb87ff785',
  video_play:
    'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Fvideoplay.png?alt=media&token=ef342c7b-16fc-4a2c-b245-8e9eb87ff785',
  app_logo:
    'https://images.ctfassets.net/6v3c95narsix/46TdQdAUAQMY1THcYm7kHL/9c7fdb28efe046377618b39e1a0ffde3/Teamcamp_default.svg'
};
